import { render, staticRenderFns } from "./riskAnalysis.vue?vue&type=template&id=7c970d99&scoped=true&"
import script from "./riskAnalysis.vue?vue&type=script&lang=js&"
export * from "./riskAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c970d99",
  null
  
)

export default component.exports